import { FC, useCallback, useEffect, useState } from 'react';

import { useChatContext } from '../context/ChatContext.tsx';
import { useMainContext } from '../context/MainContext.tsx';
import Contact from './Contact.tsx';
import HelpPanel from './HelpPanel.tsx';
import ResponsiveDrawer from './ResponsiveDrawer.tsx';

export const HelpDrawer: FC = () => {
  const { isHelpDrawerOpen, setIsHelpDrawerOpen } = useMainContext();

  const [shouldCloseHelpDrawerOnChatReady, setShouldCloseHelpDrawerOnChatReady] = useState(false);
  const { isChatLoading, isChatReady, openChat } = useChatContext();

  const handleChatRequest = useCallback(() => {
    if (isChatReady) {
      setIsHelpDrawerOpen(false);
      openChat();
      return;
    }

    openChat();
    setShouldCloseHelpDrawerOnChatReady(true);
  }, [isChatReady, openChat, setIsHelpDrawerOpen]);

  useEffect(() => {
    if (shouldCloseHelpDrawerOnChatReady && isChatReady) {
      setIsHelpDrawerOpen(false);
      setShouldCloseHelpDrawerOnChatReady(false);
    }
  }, [isChatReady, setIsHelpDrawerOpen, shouldCloseHelpDrawerOnChatReady]);

  return (
    <ResponsiveDrawer
      closeDrawer={() => {
        setIsHelpDrawerOpen(false);
      }}
      isHelpDrawerOpen={isHelpDrawerOpen}
    >
      <HelpPanel
        onClose={() => {
          setIsHelpDrawerOpen(false);
        }}
      >
        <Contact isChatLoading={isChatLoading} openLiveChatBtnOnClick={handleChatRequest} />
      </HelpPanel>
    </ResponsiveDrawer>
  );
};
